import React, { useState, useEffect } from 'react';
import { t, isRTL } from '../utils/i18n';
import './Loader.css';

export const LoadingPage = () => {
  const [stepIndex, setStepIndex] = useState(0);

  const steps = [
    t('verifyingCard'),
    t('connectingBank'),
    t('waitingConfirmation'),
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStepIndex((prev) => (prev < steps.length - 1 ? prev + 1 : prev));
    }, 3500);
    return () => clearInterval(interval);
  }, [steps.length]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f5f7fa',
        padding: '24px',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
      dir={isRTL() ? 'rtl' : 'ltr'}
    >
      <div
        style={{
          background: '#ffffff',
          borderRadius: '14px',
          boxShadow: '0 8px 30px rgba(0, 0, 0, 0.08)',
          padding: '40px 32px',
          maxWidth: '380px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <h3 style={{ margin: '0 0 10px', fontSize: '18px', color: '#1a2332', fontWeight: 700 }}>
          {t('processingTitle')}
        </h3>
        <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#4a5568', minHeight: '20px' }}>
          {steps[stepIndex]}
        </p>
        <p style={{ margin: 0, fontSize: '12px', color: '#8a94a6' }}>
          {t('doNotClose')}
        </p>
      </div>
    </div>
  );
};

export default LoadingPage;
